import { Controller } from '@hotwired/stimulus';
import Quill from '../../modules/admin/quill';
import { replaceBulletListQuillElements } from '../../modules/utils/replaceBulletListQuillElements';

const DEFAULT_TOOLBAR = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [
    'bold',
    'italic',
    'underline',
    'strike',
    { script: 'super' },
    { script: 'sub' },
    'link',
  ],
  ['blockquote', 'code-block', 'image'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ align: ['center', 'right', 'justify', false] }],
  [{ indent: '-1' }, { indent: '+1' }],
];

const TOOLBAR_FOR_EXTERNAL_PROGRAMS = [
  [
    'bold',
    'italic',
    'underline',
  ],
  [{ list: 'bullet' }],
];

export default class extends Controller {
  /* eslint-disable class-methods-use-this */
  static targets = ['editor', 'input', 'default', 'label'];

  focusout () {
    this.filledStyles();
  }

  focusin () {
    if (this.hasLabelTarget) {
      this.labelTarget.classList.add('filled');
      if (this.labelTarget.classList.contains('form__input--invalid')) {
        this.labelTarget.classList.remove('form__input--invalid');
      }
    }
  }

  connect () {
    const quill = new Quill(this.editorTarget, {
      modules: {
        toolbar: this.toolbarOptions(),
        imageResize: {
          displaySize: true,
          displayStyles: {
            backgroundColor: 'black',
            border: 'none',
            color: 'white',
          },
          modules: ['Resize', 'DisplaySize', 'Toolbar'],
        },
      },
      theme: 'snow',
    });

    quill.container.firstChild.innerHTML = this.inputTarget.value.replaceAll('\n', '').replaceAll('<ul>', '<ol>').replaceAll('</ul>', '</ol>');

    if (this.hasLabelTarget && document.getElementById('js-rich-text-content').value !== '') {
      this.labelTarget.classList.remove('hidden');
    }

    /* eslint-disable-next-line func-names */
    this.inputTarget.closest('form').onsubmit = function () {
      const body = document.getElementById('js-rich-text-content');
      if (quill.root.innerHTML !== '<p></p>' && quill.root.innerHTML !== '<p><br></p>') {
        body.value = replaceBulletListQuillElements(quill.root.innerHTML);
      } else {
        body.value = '';
      }
    };
  }

  filledStyles () {
    if (this.hasLabelTarget && !this.editorIsEmpty()) {
      this.labelTarget.classList.add('filled');
    } else if (this.hasLabelTarget && this.editorIsEmpty()) {
      this.labelTarget.classList.remove('filled');
    }
  }

  editorIsEmpty () {
    return this.editorTarget.getElementsByClassName('ql-editor')[0].innerHTML === '<p></p>' || this.editorTarget.getElementsByClassName('ql-editor')[0].innerHTML === '<p><br></p>';
  }

  toolbarOptions () {
    if (this.hasDefaultTarget) {
      return DEFAULT_TOOLBAR;
    }
    return TOOLBAR_FOR_EXTERNAL_PROGRAMS;
  }
}
